<my-widget-config
        [widgetComponent]="this"
        addTitle="{{'Embed livestream' | translate}}"
        editTitle="{{'Livestreams' | translate}}"
>
    <ng-template #widgetParamsTemplate let-widget="widget">
        <my-field
                label="{{'Channel name' | translate}}"
                placeholder="TwitchUsername"
                [(value)]="widget.dimension.newData.channelName"
                [disabled]="isUpdating"
        ></my-field>
    </ng-template>
</my-widget-config>
